import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Role API
 */
class RoleApi extends ApiBase {
  /**
   * Check if Role ID already exists
   * @param {*} roleId
   */
  async checkIdExists(roleId) {
    const request = {
      url: `${this.API_URL}/role?id=${roleId}`,
      headers: this.getHeaders(),
      method: 'HEAD',
      validateStatus: function(status) {
        return (status >= 200 && status < 300) || status === 404;
      }
    };

    const response = await axios.request(request);

    if (response.status === 200) {
      return true;
    } else if (response.status === 404) {
      return false;
    }
  }

  /**
   * Check if Role name already exists
   * @param {*} roleId
   */
  async checkNameExists(roleName) {
    const request = {
      url: `${this.API_URL}/role/existByName?name=${roleName}`,
      headers: this.getHeaders(),
      method: 'HEAD',
      validateStatus: function(status) {
        return (
          (status >= 200 && status < 300) || status === 404 || status === 400
        );
      }
    };

    const response = await axios.request(request);

    if (response.status === 200) {
      return true;
    } else if (response.status === 400 || response.status === 404) {
      return false;
    }
  }
}

export default new RoleApi();
